/*
TODO
//0.Add any two stick meters, (ex: whatmeter) and it will break!!
//1. set selection off when selecting a thumb, currently rectangle selection is still there while selecting other thumb
//2. refresh thumb when press delete at keyboard, should be triggered from the lab it self down to the Thumb
//3. $ jquery is needed also iside the lab!
//4. Social layer ( views number, creator link and profile, share button)
//4.2 Destingush between show for the same signed in user and for a nother user
4.3 Change language menu
//4.3.3 Lanuage mapping!
//4.4 Logo, press on opens the home page ( also should maintain locale)
//4.5 share button functionality as here: https://github.com/nygardk/react-share
//4.5.1 set networks IDs for buttons! very important, it was facebook messager, I removed it
//4.5.3 hide share number if zero, if possible
//4.5.2 embed iframe share
//4.6 user name hyper link
//4.7 turn profile drop list into hyper links
//4.5 Try single and double quotation in description, it causes errors
//5. Hide for social page Save, Load, Save button, Save as
//6. Licesne layer
//view restriction
//allowed components
//trail
//subscription
//6.5 Update license on tab focus
//7. SEO, Google Analytics, meta tags
//7.5. Text check box keeps set unselected by it self!
//8. Classroom selection, playground.
//8.5 When sign in in another tab, the catch up is not working for classroom drop list, and the z-index failed
//9. Rich text, NGSpice log
//10. NGSpice integrtion.
10.5 show ngspice logs directly when ngspice got enabled when use it working and notes are empty
10.7 don't set notes on when viewing in mobile
999 this experiment crashes when opening! https://staging.dcaclab.com/en/experiments/9915-test-diode-readings

//12. favicon
// 13. analysis loop popups
// 14. oscoliscope canada old about popus, (types and grounds)
15. check timeout for save, should be long enough, try saving 5 slides, big descriptions
15.5 when error saving, show retry after X seconds, cancel at retry is not good idea, still we don't want to block user
retry should be automatically after X seconds
//16. Remove does not actually remove the slide!
//17. Saving does not update the thumbnail
//17.5 Check that his url is expired at cloudfront:
//6-March-2020 this file was deleted, but serverd from cloudfront
//https://s3cdn.dcaclab.com/experiments/thumbnails/000/019/000/original/uploaded-1615031103268.jpg?1615031123
//as I have read, it should stay for 24 hours before it get read from s3 again
//if it still be there after 24 hours, this should be fixed, I've checked, its removed.

//18. Saving should popup the input form, not to keep the input always visible
//19. When backspace in circuit name input, it will delete what selected at board!
//20. Prompt user before going away from lab page
//21. Saving more than 50 circuits? tell user why it has failed saving
//22. Copy components and paste is not working!
//23. Text covers show all!
//24 tinymce remove not free plugins, remove not needed plugins
//25. Set background of slide to the same as in the lab! ;)
//26. Zoom at menu to avoid getting covered by text
//28. Zooming bars in lab needs invalidate to show
//29. Prevent click on a slide while opening
//30. select a slide, why opening all components in seqence?
31. window.view_only_mode consicuences
//32. stackable for main menu, test with mobile, user menu test with mobile
33. haxe scrollers handlers not working at edges
34. share like circuitlab
35. Make sure iframe still work after deployment
careful, debug mode for ngspice logs will make browser issesponsive specially for long logs
http://localhost:3000/en/experiments/19005-3-xx
Uncaught TypeError: Window.channel is undefined

after test
//notification style is broken on staging!
//experiment title is not at the page head or title(hover over tab to see its not..)
//avoid opening empty notes when open a circuit
//enlarge user card width at show mode, check here: https://staging.dcaclab.com/en/experiments/18163-margarita-maria-cecilia-pinzon-serrano-901-1
this circuit breaks only when using react https://staging.dcaclab.com/en/experiments/17335-practica-6-1 it has worked on production without react
NGSpice when load circuit and is not connected yet, checking it will not load the simulation, unless it was checked before..
example: https://staging.dcaclab.com/en/experiments/18345-alvaro-perez-y-daniel-viveros-ejs-12-y-3
check for connecting, then you have to uncheck and check again for simulation, while this should be one check only for connecting and simulation.
//animate.css is not loaded!

open top ten circuits at staging, one of them will break
adding oscoliscope bin on stage breaks on staging!

https://react-rte.org/demo

//*. Create two sliders, delete the first one, the second one is actually deleted!
*. iframe does not work!
*. two versions to have: with webgl and without, have the webgl fixed, let there a setting for it and automated deploy.
*. transformer is fixed for non ngspice? but its not as the same as ngspice, seems ngspice should be inverted
//*. property inspector, units are not shown for droplist, fixed
*. properties inspector locked, user needs to sign in, he signed in, he is subscriber or within trial, inspector still blocked! he needs to refresh the page to make it work
*. thumbnail capture is not working! it seems not working for new experiments?

*/
import React, { Component } from 'react';
import { Grid, Button, Confirm } from 'semantic-ui-react';
import Slide from './Slide'
import * as Tone from "tone";
const synth = new Tone.Synth().toDestination();

let sounds = new Map();
const vol = new Tone.Volume(-35).toDestination();
class Thumbs extends Component {

    refreshing_thumb = false;
    syncing = false;
    slides_to_open = 0;
    constructor(props){
        super(props);

        window.thumbs = this;
        this.state = { is_confirming: -1, opening: false, finished_opening: false, current_slide: -1, slides: []};
    }
    playNote = (note) => {
        synth.triggerAttackRelease(`${note}4`, "16n");
    }
    switchAudio = (id, off, form = 'sine') => {
        Tone.start();
        id = "switch"
        if (sounds.has(id) == false){
            sounds.set(id, new Tone.Synth({
                oscillator: {
                    type: form,
                    modulationFrequency: 0.2
                },
                envelope: {
                    attack: 0,
                    decay: 0.1,
                    sustain: 0,
                    release: 0.1,
                }
            }).connect(vol));
        }
        let osc = sounds.get(id);

        if (osc.state != "started") {
            try {
                osc.triggerAttackRelease(440, '8n');
            } catch (e) {
                console.log(e);
            }

        }

    }
    connected = (doer)=>{
        Tone.start();
        this.switchAudio(doer, true, "triangle");
    }
    fanAudio = (id, freq)=>{
        Tone.start();
        if (sounds.has(id) == false){
            sounds.set(id, new Tone.Oscillator(440, "sawtooth10").connect(vol));
        }
        let osc = sounds.get(id);
        freq = Math.abs(freq);
        try {
            if (osc.state != "started") {
                osc.start();
            }
        } catch (e) {
            console.log(e);
        }


        if (freq < 2)
            osc.stop();

        osc.set({
            frequency: freq* 8,
            amplitude: -100
        });


    }
    setConfirm = (i) => {
      this.setState({ is_confirming: i })
    }

    lab(command, arg = null){
        try {
            return com.clientside.main.Html5Bootstrap.jsCall(command, arg);
        } catch (e) {
            console.log(e);
        }
        return "";
    }
    lab_state(){
      return {bg_color: '#'+this.lab("getBGColor").toString(16), base64_shapshot: this.lab("captureLab"), data: this.lab("getCircuit"), text: this.props.getDescription()}
    }


    //called when user alter anything on circuit at haxe side
    sync(text_only= false){
        if (this.state.slides[0]!=null)

        if (!this.syncing) {
            this.syncing = true;
            let slides = [...this.state.slides];
            let labstate = text_only ? {...slides[this.state.current_slide], text: this.props.getDescription()} : this.lab_state();
            slides[this.state.current_slide] = labstate;
            this.setState({slides});
            this.syncing = false;
        }
    }
    lab_is_loaded(circuits, descriptions){
      let slides = circuits.map((circuit, index) => (
        {...this.lab_state(), data: circuit, text: descriptions[index]}
      ))
      let current_slide = window.action_name == 'lab' ? 0 : -1;
      let restore = false; //I am not sure when to restore the work, maybe ask him first?

      if (restore && localStorage.getItem('offlineCircuit')!= undefined){
        let offline_slide = JSON.parse(localStorage.getItem('offlineCircuit'));
        slides=[offline_slide];
        current_slide = -1
      }

      this.slides_to_open = slides.length;
      this.setState(
        {opening: true, current_slide, slides}
      );

      this.props.setLabLoaded(true)
      this.lab("insideReact", this.props.is_mobile);
    }
    componentDidUpdate(prevProps, prevState){


      if (this.state.opening && this.state.current_slide >= 0 && !this.refreshing_thumb)
      {
        const slide = this.state.slides[this.state.current_slide];
        const base64_shapshot = (slide == null) ? "" : slide.base64_shapshot;

        let num = this.state.current_slide-(base64_shapshot == "" ? 0 : 1);

        if (num< 0)num= 0;
        this.setState(
          {opening: num > 0,
            current_slide: this.state.current_slide > 0 ? this.state.current_slide - 1 : 0 , slides: this.state.slides}
        );
      }
      else
      if (this.state.opening && prevState.current_slide == -1)
      {
        //trigger slides capturing
        this.select(this.state.slides.length-1);
      }
    }

    set_circuit(circuit, byClick = false){
      //clear all haxe timers
      var highestTimeoutId = setTimeout(";");
      for (var t = 0 ; t < highestTimeoutId ; t++) {
          clearTimeout(t);
      }

      if (this.slides_to_open >= 0){ // >= will make animate true only when first opened the experiment
        this.slides_to_open--;
        // if (circuit['text'] && circuit['text'].length)
        // console.log("L:" + circuit['text']);
        const empty_string = '<p><br data-mce-bogus="1"></p>';
        if (this.slides_to_open == 0 && circuit && circuit['text'] && circuit['text'].length > 0 && circuit['text'] != empty_string) this.props.setVisible(true)
      }
      const animate = this.slides_to_open == 0 || byClick;
      com.clientside.main.Html5Bootstrap.jsCall("setCircuit", circuit.data, animate);

      this.props.setDescription(circuit.text)
      if (!animate && this.state.current_slide >=0)
      {
        this.refreshing_thumb = true;
      }
    }
    refresh_current_thumb =()=>{

      var slides = [...this.state.slides];
      slides[this.state.current_slide] = this.lab_state();
      this.refreshing_thumb = false;
      this.setState(
        {current_slide: this.state.current_slide, slides}
      );

      if (localStorage.getItem('triedToSave') != undefined && this.props.user){
        localStorage.setItem('triedToSave', undefined)
      }
    }
    select = (i) =>{

        // this.playNote("C");

      this.setState(
        {...this.state, current_slide: i}
      );

    }
    delete = (index) =>{

      let current_slide = this.state.current_slide;
      if (index <= current_slide){
        current_slide--;
        if (current_slide < 0)current_slide = 0;
      }
      var slides = [...this.state.slides];
      slides.splice(index, 1);
      console.log(slides, current_slide);



      this.setState({
        current_slide, slides: slides
      });
      // this.select(current_slide+1)

      setTimeout(()=>{
        this.set_circuit(this.state.slides[current_slide], !window.thumbs.state.opening);

      }, 1)




    }
    add_slide = (duplicate = false) =>{
      this.refresh_current_thumb();
      if (!duplicate){
        this.lab("newCircuit")
      }
      this.setState(
        {current_slide: this.state.slides.length, slides: [...this.state.slides,
          {bg_color: '#'+this.lab("getBGColor").toString(16), base64_shapshot: this.lab("captureLab"), data: this.lab("getCircuit"), text: ""}
        ]}
      );
      if (!duplicate){
        setTimeout(()=>{
          this.props.setDescription("")
        }, 1)
      }

    }
    duplicate_slide = () => {
      const circuit = this.lab_state();
      this.add_slide(true);
      this.setState(
        {current_slide: this.state.current_slide, slides: [...this.state.slides, circuit]}
      );

    }
    remove_slide(){
    }

  render() {
    return (
      <div>
        <p style={{textAlign: 'center', color: this.props.forecolor}}>{l.slides}</p>
        {this.state.slides.map((slide_info, index) => (
        <Slide setConfirm={this.setConfirm} key={index} single={this.state.slides.length == 1}
        select={(i)=>this.select(i)}
        number={index+1} selected={index == this.state.current_slide}
        opening={this.state.opening}
        circuit={slide_info}
        set_circuit={(circuit, byUser)=>this.set_circuit(circuit, byUser)}
        />
        ))}
        {this.state.slides.length > 0 &&
        <Grid style={{marginLeft: 2, paddingTop: 20}}>

            <Button disabled={this.state.slides.length >= 5}  icon='add' onClick={()=>{
                window.thumbs.sync();
                setTimeout(()=>{
                  this.add_slide()
                }, 1)
              }} size='mini' />
            <Button disabled={this.state.slides.length >= 5} icon='copy' onClick={()=>this.duplicate_slide()} size='mini' />

        </Grid>
        }

      <Confirm
        open={this.state.is_confirming >= 0}
        onCancel={()=>this.setConfirm(-1)}
        onConfirm={(e)=>{
          e.stopPropagation();
          this.delete(this.state.is_confirming);
          this.setConfirm(-1);
        }
        }
        size='mini'
        />
    </div>
    );
  }
}

export default Thumbs;
